import React from 'react';
import InformationContainer from './InformationContainer';

const tPrefix = 'products-fe.pages.whats_next_page.disabled';

const Disabled = props => <InformationContainer tPrefix={tPrefix} hasFooter {...props} />;

export default Disabled;
